export default __webpack_public_path__ + "static/img/about-bg.34e4dfc.jpg";